import { Grid, Typography } from '@mui/material'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { StyledCard } from '../../../../../../components/StyledCard'
import { TechnologySelectors } from '../../../../../../store/technology'
import { ProjectKeywords } from './ProjectKeywords'
import { ProjectMembers } from './ProjectMembers'

export const ProjectOverview: FC = () => {
  const { title = '', description = '' } = useSelector(TechnologySelectors.getTechnology)

  return (
    <Grid container spacing={2}>
      <Grid item xs={7}>
        <StyledCard sx={{ p: 1.5, height: '100%' }}>
          <Typography
            variant="h5"
            sx={{ fontSize: '1.5rem', fontWeight: 500, color: 'secondary.main' }}
          >
            {title}
          </Typography>
          <Typography
            my="0.8rem"
            fontWeight={500}
            fontSize="0.875rem"
            color="secondary.light"
            whiteSpace="break-spaces"
          >
            {description}
          </Typography>
        </StyledCard>
      </Grid>

      <Grid item xs={5}>
        <ProjectKeywords />
      </Grid>

      <Grid item xs={12}>
        <ProjectMembers />
      </Grid>
    </Grid>
  )
}
